/**
 * Module: Forms (Resilient Enterprise Version)
 * Agnostic Form Handling, Tracking & Validation
 */
import { trackLead, trackConversion } from './analytics.js';

export default (form) => {
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalBtnText = submitBtn ? submitBtn.innerHTML : '';
    const statusContainer = document.createElement('div');
    statusContainer.className = 'form-status-container mt-4 animate-fade-in hidden';
    form.appendChild(statusContainer);

    const showStatus = (message, type = 'success') => {
        statusContainer.classList.remove('hidden');
        const bgClass = type === 'success' ? 'bg-theme-success/10 border-theme-success/20 text-theme-success' : 'bg-theme-error/10 border-theme-error/20 text-theme-error';
        
        statusContainer.innerHTML = `
            <div class="flex items-center gap-3 p-4 rounded-theme-lg border ${bgClass} font-medium text-theme-small">
                <span class="flex-shrink-0">${message}</span>
            </div>
        `;
        
        if (type === 'success') {
            setTimeout(() => {
                statusContainer.classList.add('hidden');
            }, 5000);
        }
    };

    const validate = () => {
        const inputs = form.querySelectorAll('[required]');
        let isValid = true;

        inputs.forEach(input => {
            if (!input.value.trim()) {
                input.classList.add('border-theme-error');
                isValid = false;
            } else {
                input.classList.remove('border-theme-error');
            }

            if (input.type === 'tel' && input.value) {
                const telRegex = /^[+]?[\d\s-]{7,15}$/;
                if (!telRegex.test(input.value)) {
                    input.classList.add('border-theme-error');
                    isValid = false;
                }
            }

            if (input.type === 'email' && input.value) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(input.value)) {
                    input.classList.add('border-theme-error');
                    isValid = false;
                }
            }
        });

        return isValid;
    };

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // 1. Client-side Validation
        if (!validate()) {
            showStatus('Por favor, verifique los campos marcados en rojo.', 'error');
            return;
        }

        const leadType = form.dataset.leadType || 'Formulario';
        const leadLabel = form.dataset.leadLabel || form.id;
        
        // 2. Estado de Carga (Staff UX)
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.innerHTML = `
                <div class="flex items-center justify-center gap-2">
                    <svg class="animate-spin h-5 w-5" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>Procesando...</span>
                </div>
            `;
        }

        try {
            const formData = new FormData(form);
            
            // Capture user data for Thank You page conversion (Staff Enterprise)
            const email = formData.get('email');
            const phone = formData.get('phone') || formData.get('telefono');
            if (email) sessionStorage.setItem('ec_email', email);
            if (phone) sessionStorage.setItem('ec_phone', phone);

            const response = await fetch(form.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (response.ok) {
                // 3. Éxito: Tracking + UI
                trackLead(leadType, leadLabel);
                trackConversion();
                
                // Construct WhatsApp Redirection (Enterprise Immediate Response)
                const name = formData.get('nombre') || formData.get('name') || 'Cliente';
                const userMessage = formData.get('mensaje') || formData.get('message') || '';
                const service = formData.get('servicio') || '';
                
                let waMessage = `Hola Vidrería El Cristal, mi nombre es ${name}. `;
                if (service) waMessage += `Estoy interesado en el servicio de ${service}. `;
                if (userMessage) waMessage += `Consulta: ${userMessage}`;
                
                const waUrl = `https://wa.me/51985003153?text=${encodeURIComponent(waMessage)}`;

                // Transición suave al estado de éxito
                form.innerHTML = `
                    <div class="text-center py-10 animate-fade-in flex flex-col items-center">
                        <div class="w-16 h-16 bg-theme-success/10 text-theme-success rounded-theme-full flex items-center justify-center mb-6 border border-theme-success/20">
                            <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
                        </div>
                        <h3 class="text-theme-h2 font-bold text-white mb-2">¡Mensaje Recibido!</h3>
                        <p class="text-theme-neutral-300">Gracias por contactarnos. Redirigiendo a WhatsApp para atención inmediata...</p>
                    </div>
                `;

                setTimeout(() => {
                    window.location.href = waUrl;
                }, 1500);
            }
 else {
                throw new Error('Server error');
            }
        } catch (error) {
            console.error('❌ [Forms] Error:', error);
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.innerHTML = originalBtnText;
                showStatus('Error al enviar. Por favor intente por WhatsApp.', 'error');
            }
        }
    });
};
